/**
 * Dietary requirements CSV, built client-side from the attendee roll.
 *
 * HIGH sensitivity: dietary text is free text about a student. The file holds
 * names, student number, compass group and the text, never carer details.
 * Pure: no DOM, no logging.
 */
export interface DietaryCsvRow {
	surname: string;
	givenName: string;
	studentNumber: string;
	compassGroup: string;
	dietary: string;
}

const HEADER = ["Surname", "Given Name", "Student No", "Compass", "Dietary"];

/** A leading = + - @ tab or CR makes a spreadsheet read the cell as a formula. */
function cell(value: string): string {
	const guarded = /^[=+\-@\t\r]/.test(value) ? `'${value}` : value;
	return `"${guarded.replace(/"/g, '""')}"`;
}

export function dietaryRowCount(rows: DietaryCsvRow[]): number {
	return rows.filter((r) => r.dietary.trim()).length;
}

export function buildDietaryCsv(rows: DietaryCsvRow[]): string {
	const lines = [HEADER.map(cell).join(",")];
	for (const r of rows) {
		const dietary = r.dietary.trim();
		if (!dietary) continue;
		lines.push(
			[r.surname, r.givenName, r.studentNumber, r.compassGroup, dietary]
				.map(cell)
				.join(","),
		);
	}
	return "\uFEFF" + lines.join("\r\n") + "\r\n";
}
